module.exports = __webpack_public_path__ + "assets/img/29_239.5702808d.jpg";